import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { motion } from "framer-motion"
import { GoArrowUp } from "react-icons/go";
import HostingIntro from "./components/HostingIntro";
import HostingTable from "./components/HostingTable";
import HostingBackground from "./components/HostingBackground";

const HostingPage = ({ swiperRef }) => {

     const [content, setContent] = useState([]);

     useEffect(() => {

        
      setContent([ 
            {index : 0, id :'content01', name:'하드용량', lev1 : '2,5GB', lev2 :'5GB', lev3:'8GB' },
            {index : 1, id :'content02', name:'트래픽 용량', lev1 : '4GB', lev2 :'9GB', lev3:'20GB' },
            {index : 2, id :'content03', name:'보유도메인 연결', lev1 : '6개', lev2 :'9개', lev3:'11개' },
            {index : 3, id :'content04', name:'기술지원 및 상담', lev1 : '월 1회', lev2 :'월 1회', lev3:'월 1회' },
            {index : 4, id :'content05', name:'텍스트 수정\n(A4 용지 ½ 분량)', lev1 : '월 1회', lev2 :'월 2회', lev3:'월 3회' },
            {index : 5, id :'content06', name:'이미지 수정\n(500 x 500px 이내)', lev1 : '월 1회', lev2 :'월 2회', lev3:'월 3회' },
            {index : 6, id :'content07', name:'메인화면 이미지 수정', lev1 : '연 1회', lev2 :'연 2회', lev3:'연 3회' },
            {index : 7, id :'content08', name:'서브페이지 추가\n(A4 용지 1페이지 분량)', lev1 : '연 1회', lev2 :'연 3회', lev3:'연 5회' },
            {index : 8, id :'content09', name:'팝업창 수정 및 제작', lev1 : '연 1회', lev2 :'연 2회', lev3:'연 3회' },
      ]);
  }, []);

  const handleMouseEnter = (index) => {
    console.log(index);
  };

  const handleMouseLeave = () => {
    console.log("Mouse left");
  };

  const moveToFirstSlide = () => {
    
    swiperRef.current.swiper.slideTo(0);
  };

  
      return (
        <div className="w-full min-h-screen">
          <HostingBackground>
            <HostingIntro />
          <div className="flex items-center justify-center -mt-1 pb-16">
            <div className="w-full max-w-[1300px] px-5 lg:px-0">
              <HostingTable content={content} />
            </div>
          </div>
          </HostingBackground>
        </div>
      );
  };

export default HostingPage;